export enum Modals {
  ApiTokenDestroyModal = 'apiTokenDestroyModal',
  ApiTokenFormModal = 'apiTokenFormModal',
  DashboardMonitoringFilterModal = 'dashboardMonitoringFilterModal',
  DashboardOverviewFilterModal = 'dashboardOverviewFilterModal',
  DashboardTimelineFilterModal = 'dashboardTimelineFilterModal',
  DataImportDestroyModal = 'dataImportDestroyModal',
  DataImportErrorsModal = 'dataImportErrorsModal',
  DestroyModal = 'destroyModal',
  FilterModal = 'filterModal',
  GenerateReportModal = 'generateReportModal',
  HomeApplyTemplateModal = 'homeApplyTemplateModal',
  HomeCustomizeTabsModal = 'homeCustomizeTabsModal',
  HomePublishModal = 'homePublishModal',
  HomeWidgetModal = 'homeWidgetModal',
  HowToUseApi = 'howToUseApi',
  LegendFormModal = 'legendFormModal',
  MoveMembersToTeamModal = 'moveMembersToTeamModal',
  SiteCodeOfConductDestroyModal = 'siteCodeOfConductDestroyModal',
  SiteDestroyModal = 'siteDestroyModal',
  SiteListFilter = 'siteListFilter',
  TeamDestroyModal = 'teamDestroyModal',
  UserDeleteModal = 'userDeleteModal',
  UserFormModal = 'userFormModal',
}
